module.exports = "/_next/static/images/3ee6da210eeeb6dff9df30590448875f-blog4-xs.png.webp";